import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
    selector: '[isEmail]',
    providers: [{provide: NG_VALIDATORS, useExisting: EmailDirective, multi: true}]
})
export class EmailDirective implements Validator {

    public constructor() {}

    public validate(control: AbstractControl): {[key: string]: any} {
        let emailRegEx = /^[a-z0-9_-]+(?:\.[a-z0-9_-]+)*@(?:[a-z0-9](?:[‌​a-z0-9-]*[a-z0-9])?\.){1,3}[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        /*
            emailRegEx is the Regex Express to validate the email address in the following formats
            1.) abc.def@ghi.jkl  === True
            2.) abc_def@ghi.jkl === True
            3.) abc@def.ghi.jkl === True
            4.) abc@def.ghi.jkl.mn === True
            5.) abc-def@ghi.jkl === True

            In general input will be false if the contains any other special characters other than ( _ and . and - ) and
            if the input email contains more than 3 dots(.) after @
        */
        let valid = emailRegEx.test(control.value);
        return control.value < 1 || valid ? null : {'isEmail': true};
    }

}